import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IMoleState } from "./IMoleState";

export class IdleToRepeatState implements IMoleState {
    private currentTimeout: number;
    private nextState: IMoleState;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState,
        private readonly idleTimeout: number
    ) {
    }

    public enter(previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        if (!(previousState instanceof FreezeState)) {
            this.currentTimeout = this.idleTimeout;
            this.nextState = previousState;
            this.animationController.transitToState(MoleAnimationState.Idle);
        }
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        this.currentTimeout = Math.max(this.currentTimeout - dt, 0);
        if (this.currentTimeout == 0) {
            return this.nextState;
        }
        return this;
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.animationController.transitToState(MoleAnimationState.Idle);
    }
}